export default "__VITE_ASSET__Dp50fh_o__"